import React from 'react';
import './WelcomeSection.css';
import Carousel from '../Carousel/Carousel';


// Images for Carousel
import image1 from '../../resources/assets/images/QueenBed2.png';
import image2 from '../../resources/assets/images/Sofa2.png';
import image3 from '../../resources/assets/images/Nightstand3.png';

const WelcomeSection = () => {

    const carouselImages = [
        {
        src: image1,
        },
        {
        src: image2,
        },
        {
        src: image3,
        }
    ];
    
  return (
    <section className="welcome-section">
      <div className="welcome-left" data-aos="fade-right">
        <h1>
          Boost growth with <span className="highlight">Kozee’s furniture export solutions.</span>
        </h1>
        <p>
Backed by two decades of OEM expertise, Kozeé empowers global brands through reliable export partnerships. Our experience in international logistics and scalable RTA furniture production ensures efficient, stylish, and dependable delivery to markets worldwide.
        </p>
        <div className="cta-group">
          <a href="/contact" className="primary-cta">Talk to us</a>
          <a href="/export" className="secondary-cta">View our exports</a>
        </div>
      </div>

      <div className="welcome-right" data-aos="fade-left">
        <div className="image-wrapper">
            <Carousel images={carouselImages} />
        </div>
      </div>
    </section>
  );
};

export default WelcomeSection;
